export default __webpack_public_path__ + "static/media/termlife_file_download_icon.a16c6aa4.svg";